enum STATUS_CODE {
  SUCCESS = 200
}

export default STATUS_CODE;
